export const ContactsActionTypes = {
  API_RESPONSE_SUCCESS: '@@contacts/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@contacts/API_RESPONSE_ERROR',

  GET_CONTACT: '@@contacts/GET_CONTACT',
  LIST_CONTACTS: '@@contacts/LIST_CONTACTS',
  ADD_CONTACT: '@@contacts/ADD_CONTACT',
  UPDATE_CONTACT: '@@contacts/UPDATE_CONTACT',
  DELETE_CONTACT: '@@contacts/DELETE_CONTACT',

  RESET: '@@contacts/RESET'
}
